import { useForm } from "react-hook-form";
import {
  NewTableContainer,
  TableContainer,
} from "../../style/contents/backup/backup";
import { UserProfile } from "../../view/contents/user/user.list";
import Pagination from "../common/table.pagination";
import { useEffect, useMemo, useState } from "react";
import {
  getSortedRowModel,
  PaginationState,
  SortingState,
} from "@tanstack/react-table";
import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  Row,
  useReactTable,
} from "@tanstack/react-table";
import TableCheckBox from "../common/table.checkbox";
import ModalCenterLayout from "../modal/modal.center.layout";
import ModifyModal from "./modal/modify.modal";
import { fetchUserEditProfile, ResponseData } from "../../api/admin";
import { formatDate } from "../../util/util";
import DeleteModal from "./modal/delete.modal";
import RegistModal from "./modal/regist.modal";

interface Props {
  data: UserProfile[];
  pageSize: number;
  paginationEnabled?: boolean;
  onUpdateSuccess: () => void; // ✅ 추가
  isLoading?: boolean; // ✅ 추가
}

export interface ModalProps {
  isOpen: boolean;
  isVisible: boolean;
}

const UserTableList = ({
  data,
  pageSize,
  paginationEnabled = true,
  onUpdateSuccess,
  isLoading,
}: Props) => {
  const { register, handleSubmit } = useForm();
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize,
  });
  const [rowSelection, setRowSelection] = useState<Record<string, boolean>>({});
  const [selectedUser, setSelectedUser] = useState<UserProfile | null>(null);

  const [registModal, setRegistModal] = useState<ModalProps>({
    isOpen: false,
    isVisible: false,
  });
  const [modifyModal, setModifyModal] = useState<ModalProps>({
    isOpen: false,
    isVisible: false,
  });
  const [delModal, setDelModal] = useState<ModalProps>({
    isOpen: false,
    isVisible: false,
  });

  const [sorting, setSorting] = useState<SortingState>([
    { id: "userName", desc: false },
  ]);

  const columns = useMemo<ColumnDef<UserProfile>[]>(
    () => [
      {
        id: "select",
        header: "선택",
        cell: ({ row }) => (
          <div className="px-1">
            <TableCheckBox
              {...{
                checked: row.getIsSelected(),
                disabled: !row.getCanSelect(),
                indeterminate: row.getIsSomeSelected(),
                onChange: row.getToggleSelectedHandler(),
                onClick: (e) => e.stopPropagation(),
              }}
            />
          </div>
        ),
        size: 50,
        enableSorting: false, // ❌ 정렬 비활성화
      },
      // {
      //   header: "No.",
      //   id: "number", // 넘버링을 위한 id
      //   // cell: ({ row }) => row.index + 1, // 각 행의 인덱스에 1을 더해 넘버링
      //   cell: ({ row }: { row: Row<UserProfile> }) => {
      //     const totalCount = data.length; // totalRowCount = 전체 데이터 수
      //     if (totalCount === 0) return "-";

      //     const globalIndex = row.index; // 이미 글로벌 인덱스임
      //     return totalCount - globalIndex;
      //   },
      //   size: 60,
      // },
      {
        header: "아이디",
        accessorKey: "userAccount",
        cell: (info) => info.getValue(),
        size: 200,
        enableSorting: false, // ❌ 정렬 비활성화
      },
      {
        header: "부서명",
        accessorKey: "department",
        cell: (info) => (info.getValue() ? info.getValue() : "-"),
        size: 200,
        enableSorting: true, // ✅ 정렬 가능
      },
      {
        header: "이름",
        accessorKey: "userName",
        cell: (info) => (info.getValue() ? info.getValue() : "-"),
        size: 200,
        enableSorting: true, // ✅ 정렬 가능
      },
      {
        header: "직위",
        accessorKey: "jobPosition",
        cell: (info) => (info.getValue() ? info.getValue() : "-"),
        size: 200,
        enableSorting: false, // ❌ 정렬 비활성화
      },
      {
        header: "권한",
        accessorKey: "isAdmin",
        cell: (info) => {
          const value = info.getValue();
          if (value) return "관리자";
          else return "사용자";
        },
        size: 200,
        enableSorting: false, // ❌ 정렬 비활성화
      },
      {
        header: "등록일",
        accessorKey: "createdDate",
        cell: ({ getValue }) => {
          const raw = getValue() as string;
          return raw ? formatDate(raw) : "-";
        },
        size: 200,
        enableSorting: true, // ✅ 정렬 가능
      },
    ],
    [register, data, pagination],
  );

  const table = useReactTable({
    data,
    columns,
    state: {
      rowSelection,
      pagination,
      sorting,
    },
    enableSorting: true,
    onSortingChange: setSorting,
    onRowSelectionChange: setRowSelection,
    enableRowSelection: (row) => !row.original.isPreview,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: paginationEnabled
      ? getPaginationRowModel()
      : undefined,
    getSortedRowModel: getSortedRowModel(), // ✅ 이 줄 추가!!
    onPaginationChange: setPagination,
  });

  const selectedRowCount = table.getSelectedRowModel().rows.length;
  const totalRowCount = table.getRowCount();

  const onSubmit = async (data: any) => {
    console.log(data);
  };

  useEffect(() => {
    if (data.length > 0) {
      table.setPageSize(pageSize);
    }
  }, [table, pageSize, data]);

  const registModalClosed = () => {
    setRegistModal({ isOpen: false, isVisible: false });
  };
  const registModalOpened = () => {
    setRegistModal({ isOpen: true, isVisible: true });
  };
  const modifyModalClosed = () => {
    setModifyModal({ isOpen: false, isVisible: false });
  };
  const modifyModalOpened = () => {
    setModifyModal({ isOpen: true, isVisible: true });
  };
  const delModalClosed = () => {
    setDelModal({ isOpen: false, isVisible: false });
  };
  const delModalOpen = () => {
    setDelModal({ isOpen: true, isVisible: true });
  };

  const handleModifyClick = () => {
    const selectedRows = table.getSelectedRowModel().rows;

    if (selectedRows.length !== 1) {
      alert("수정은 하나의 사용자만 선택할 수 있습니다.");
      return;
    }

    const userData = selectedRows[0].original;
    setSelectedUser(userData);
    modifyModalOpened();
  };

  const handleDeleteClick = async () => {
    const selectedRows = table.getSelectedRowModel().rows;
    if (selectedRows.length === 0) {
      alert("삭제할 사용자를 선택해주세요.");
      return;
    }

    const adminUserId = localStorage.getItem("userId") ?? "";

    try {
      const responses = await Promise.all(
        selectedRows.map(async (row) => {
          const user = row.original;
          console.log(user);
          const responseData: ResponseData = {
            adminUserId,
            userId: user.userId,
            username: user.userName,
            userEmail: user.userEmail ?? "",
            phoneNumber: user.phoneNumber ?? "", // 필요 시 수정
            jobPosition: user.jobPosition ?? "", // 필요 시 수정
            department: user.department ?? "",
            permission: user.isAdmin ? "admin" : "client",
            disable: true, // ✅ 삭제 처리
          };

          const res = await fetchUserEditProfile(responseData);
          console.log(`✅ 삭제 응답 - ${user.userAccount}:`, res); // ✅ 개별 응답 확인
          return res;
        }),
      );

      alert("선택한 사용자를 삭제 처리했습니다.");
      onUpdateSuccess(); // ✅ 리스트 새로고침
      setRowSelection({}); // ✅ 체크박스 초기화
    } catch (err) {
      console.error("❌ 삭제 처리 실패:", err);
      alert("삭제 처리 중 오류가 발생했습니다.");
    }
  };

  const handleUpdateSuccess = async () => {
    await onUpdateSuccess(); // ✅ 유저 목록 다시 불러오기 (loadUserList)
    setRowSelection({}); // ✅ 체크박스 초기화
  };

  return (
    <NewTableContainer className="new_design_">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="table-head-wrap user-table">
          <div className="left">
            <span className="table-total-row">
              <TableCheckBox
                {...{
                  checked: table.getIsAllRowsSelected(),
                  indeterminate: table.getIsSomePageRowsSelected(),
                  onChange: table.getToggleAllRowsSelectedHandler(),
                }}
                id="allCheck"
              />
              <label htmlFor="allCheck">
                전체 선택 ({selectedRowCount} / {totalRowCount})
              </label>
            </span>
          </div>
          <div className="right">
            <div className="btn-box multi">
              <button className="regist" onClick={registModalOpened}>
                <img src="/assets/new_design/write_icon.png" alt="" />
                <span>추가</span>
              </button>
              <button
                type="button"
                className="modify"
                onClick={handleModifyClick}
              >
                <img src="/assets/new_design/config_icon.png" alt="" />
                <span>수정</span>
              </button>
              <button
                type="button"
                className="delete"
                // onClick={handleDeleteClick} // ✅ 클릭 시 삭제 핸들러 호출
                onClick={delModalOpen}
              >
                <img src="/assets/new_design/del_icon.png" alt="" />
                <span>삭제</span>
              </button>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className="loading">데이터를 불러오는 중입니다...</div>
        ) : (
          <div className="new_design__">
            <table>
              <thead>
                {table.getHeaderGroups().map((item) => (
                  <tr key={item.id}>
                    {item.headers.map((header) => (
                      <th
                        key={header.id}
                        style={{
                          width: `${header.getSize()}px`,
                          cursor: header.column.getCanSort()
                            ? "pointer"
                            : undefined,
                        }}
                        onClick={header.column.getToggleSortingHandler()}
                      >
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                        {{
                          asc: (
                            <span className="up">
                              <img src="/assets/left-arrow.png" alt="" />
                            </span>
                          ),
                          desc: (
                            <span className="down">
                              <img src="/assets/left-arrow.png" alt="" />
                            </span>
                          ),
                        }[header.column.getIsSorted() as string] ?? null}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.length === 0 ? (
                  <tr>
                    <td colSpan={columns.length} className="no-data-row">
                      🔍 검색 결과가 없습니다.
                    </td>
                  </tr>
                ) : (
                  table.getRowModel().rows.map((row) => (
                    <tr key={row.id}>
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext(),
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </form>

      {paginationEnabled && table.getPageCount() > 0 && (
        <Pagination
          page={pagination.pageIndex}
          pages={table.getPageCount()}
          onPageChange={(page) => {
            table.setPageIndex(page); // 실제 table 내부 페이지 인덱스 업데이
          }}
        />
      )}

      {registModal.isOpen && (
        <ModalCenterLayout
          isVisible={registModal.isVisible}
          closedHandler={registModalClosed}
          size="m"
        >
          <RegistModal
            closedHandler={registModalClosed}
            onRegistSuccess={handleUpdateSuccess} // ✅ 등록 완료 시 리스트 새로고침
          />
        </ModalCenterLayout>
      )}

      {modifyModal.isOpen && selectedUser && (
        <ModalCenterLayout
          isVisible={modifyModal.isVisible}
          closedHandler={modifyModalClosed}
          size="m"
        >
          <ModifyModal
            closedHandler={() => {
              modifyModalClosed();
              handleUpdateSuccess(); // ✅ 리스트 다시 불러오기
            }}
            user={selectedUser} // 👈 사용자 정보 전달
          />
        </ModalCenterLayout>
      )}

      {delModal.isOpen && (
        <ModalCenterLayout
          isVisible={delModal.isVisible}
          closedHandler={modifyModalClosed}
        >
          <DeleteModal
            selectedUsers={table
              .getSelectedRowModel()
              .rows.map((row) => row.original)}
            closedHandler={delModalClosed}
            onDeleteSuccess={handleUpdateSuccess} // ✅ 목록 리로드 + 체크박스 초기화
          />
        </ModalCenterLayout>
      )}
    </NewTableContainer>
  );
};

export default UserTableList;
